import React, { useState, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "../services/api";
import ToastContext from "../contexts/ToastContext";
import { IMaskInput } from "react-imask";
import "./Auth.css"; // Importa o novo CSS
import backgroundImage from "../assets/imagem-prefeitura.jpg"; // Importa a imagem
import { MdCheckCircle } from "react-icons/md";
import { FaUser, FaIdCard, FaEnvelope, FaPhone, FaLock } from "react-icons/fa";

const validateCPF = (cpf) => {
  cpf = cpf.replace(/[^\d]+/g, "");
  if (cpf === "" || cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;
  let add = 0;
  for (let i = 0; i < 9; i++) add += parseInt(cpf.charAt(i)) * (10 - i);
  let rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) rev = 0;
  if (rev !== parseInt(cpf.charAt(9))) return false;
  add = 0;
  for (let i = 0; i < 10; i++) add += parseInt(cpf.charAt(i)) * (11 - i);
  rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) rev = 0;
  if (rev !== parseInt(cpf.charAt(10))) return false;
  return true;
};

function Cadastro() {
  const [formData, setFormData] = useState({
    nome: "",
    sobrenome: "",
    cpf: "",
    email: "",
    senha: "",
    telefone: "",
  });
  const { addToast } = useContext(ToastContext);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleMaskedInputChange = (value, mask) => {
    const { name } = mask.el.input;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateCPF(formData.cpf)) {
      addToast("CPF inválido.", "error");
      return;
    }
    if (formData.telefone.length < 10) {
      addToast("Número de telefone inválido.", "error");
      return;
    }

    try {
      const payload = {
        ...formData,
        cpf: formData.cpf.replace(/\D/g, ""),
        telefone: formData.telefone.replace(/\D/g, ""),
      };
      await api.post("/auth/register", payload);
      addToast("Cadastro realizado com sucesso!", "success");
      navigate("/aguardando-verificacao", {
        state: { showVerificationModal: true, registeredEmail: payload.email },
      });
    } catch (error) {
      // Log detalhado do erro no console do navegador
      console.error("Erro detalhado no cadastro:", error.response?.data);
      addToast(error.response?.data?.message || "Erro ao cadastrar.", "error");
    }
  };

  return (
    <div
      className="auth-container"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="auth-card">
        <h1>Crie sua Conta</h1>
        <form className="form-modern" onSubmit={handleSubmit}>
          <div className="form-grid">
            <div className="form-group">
              <label htmlFor="nome">Nome</label>
              <div>
                <FaUser />
                <input
                  name="nome"
                  id="nome"
                  placeholder="Nome"
                  value={formData.nome}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="sobrenome">Sobrenome</label>
              <div>
                <FaUser />
                <input
                  name="sobrenome"
                  id="sobrenome"
                  placeholder="Sobrenome"
                  value={formData.sobrenome}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="cpf">CPF</label>
              <div>
                <FaIdCard />
                <IMaskInput
                  mask={"000.000.000-00"}
                  value={formData.cpf}
                  onAccept={(value, mask) =>
                    handleMaskedInputChange(value, mask)
                  }
                  placeholder="CPF"
                  name="cpf"
                  required
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <div>
                <FaEnvelope />
                <input
                  name="email"
                  id="email"
                  type="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="telefone">Telefone</label>
              <div>
                <FaPhone />
                <IMaskInput
                  mask={"(00) 00000-0000"}
                  value={formData.telefone}
                  onAccept={(value, mask) =>
                    handleMaskedInputChange(value, mask)
                  }
                  placeholder="(XX) XXXXX-XXXX"
                  name="telefone"
                  required
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="senha">Senha</label>
              <div>
                <FaLock />
                <input
                  name="senha"
                  id="senha"
                  type="password"
                  placeholder="Senha"
                  value={formData.senha}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>
          </div>
          <div className="form-actions full-width">
            <button className="btn-modern" type="submit">
              <MdCheckCircle size={22} />
              <span>Finalizar Cadastro</span>
            </button>
          </div>
          <div className="auth-links">
            <p>
              Já tem uma conta? <Link to="/login">Faça o login</Link>
            </p>
            <small>
              Precisa de ajuda? <Link to="/faq">Acesse o FAQ</Link>
            </small>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Cadastro;
